(() => {
    class Notification extends App.Component {
        constructor(container) {
            super(container);

            this._title     = this.container.querySelector('.notification-title').innerHTML;
            this._content   = this.container.querySelector('.notification-content').innerHTML;
            this
                .refreshLinksFromDOM()
                .bind()
            ;
        }

        // Replaces the internal array of links with those currently displayed in the DOM.
        refreshLinksFromDOM() {
            this.links = [];
            this.container.querySelectorAll('.notification-link').forEach(link => {
                this.addLink(link.innerText, link.href, link.classList.contains('close'));
            });
            return this;
        }

        addLink(content, href, close) {
            this.links.push({
                content:    content,
                href:       href,
                close:      close,
            });
            return this;
        }

        setType(type) {
            this.container.dataset.type = type;
            return this;
        }

        /* GETTERS & SETTERS */
        get title() {
            return this._title;
        }

        set title(title) {
            this._title = title;
            this.render();
        }

        get content() {
            return this._content;
        }

        set content(content) {
            this._content = content;
            this.render();
        }

        get buttons() {
            let content = '';
            this.links.forEach(link => {
                content+= App.Template.parse('notification-a', link);
            });
            return content;
        }

        bind() {
            let Self = this;
            Self.$.on('click', '.close', function() {
                let container = Self.$.parents('.notification-container');
                if (container.length) App.Interface.Notification.remove(container.data('position'), Self.$.index());
                Self.$.slideUp(400, function() {Self.$.remove();});
            });
            return this;
        }

        removeLinksFromDOM() {
            this.container.querySelectorAll('.notification-link').forEach(link => {
                this.container.removeChild(link);
            });
            return this;
        }

        renderLinks() {
            let content = '';
            this.links.forEach(link => {
                content+= App.Template.parse('notification-a', link);
            });
            return content;
        }

        render() {
            let content = '';
            if (this.title) {
                content+= App.Template.parse('notification-title', this.title);
            }
            content+= App.Template.parse('notification-content', this.content);
            content+= this.buttons;
            this.container.innerHTML = content;
        }

        update() {
            this.render();
        }
    }
    // Attach an instance of this object to every element matching the selector.
    App.Components.register('.notification', Notification);
})();
